export default {"src":"/_next/static/media/bybit.ea0c374e.svg","height":28,"width":28};